import 'isotope-layout/dist/isotope.pkgd';

export default class CardGrid {
    static init() {
        if (window.innerWidth < 1024) return;

        const isNeosBackend = document.body.classList.contains('neos-backend');
        if (isNeosBackend) {
            return;
        }

        Array.prototype.forEach.call(document.querySelectorAll('.card-grid'), el => {
            new CardGrid(el)
        });
    }

    constructor(el) {
        if (!el) return;
        this.el = el;

        document.addEventListener('lazyloaded', () => {
            new Isotope(this.el, {
                itemSelector: '.card-grid__item',
                layoutMode: 'masonry'
            });
        });
    }
}
